<template>
  <vs-popup class="user-edit-popup" id="popup" title="UPDATE ACTION STATUS LOG" @close="open = false"
    :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickUpdate)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="comments" name="comments" rules="required" v-slot="{ errors }">
                <small class="label">Comments</small>
                  <vs-textarea v-model="form.comments" rows="10"></vs-textarea>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="onClickReset" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const ActionRepository = RepositoryFactory.get('action');

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import vSelect from 'vue-select'

function initialState() {
  return {
    open: false,
    form: {},
    action_id: null
  }
}

export default {
  name: 'UpdateActionStatusLogPopUp',
  data() {
    return initialState()
  },
  mixins: [SuccessMessage, ErrorMessages],
  components: {
    'v-select': vSelect,
  },

  methods: {
    async openPopup(action_id, data) {
      try {
        Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.action_id = action_id
        Object.assign(this.form, data)
        this.open = true;
      } catch (error) {
        console.log("error", error)
      }
    },

    async onClickUpdate() {
      const vue = this;
      this.$vs.loading()
      try {
        await ActionRepository.updateActionStatusLog(this.action_id, this.form._id, { comments: this.form.comments })
        await vue.$parent.refreshData()
        this.open = false;
      } catch (e) {
        this.$vs.loading.close()
        this.convertAndNotifyError(e)
      } finally {
        this.$vs.loading.close()
      }
      
    },
    onClickReset() {
      this.form.comments = ''
    }
  },
}
</script>

<style scoped>
.video-wrapper {
  width: 100%;
  height: 100%;
}

.video-wrapper video {
  object-fit: cover;
  width: 100%;
  height: 100%;

}

.image-wrapper {
  width: 100%;
  height: 75%;
}
</style>
